const StatusObjectToQuery = selectedStatus => (selectedStatus.map((status) => (status.value)).join(','))

export default StatusObjectToQuery;